import { render, staticRenderFns } from "./BunkerSurveyor.vue?vue&type=template&id=485a2836&"
import script from "./BunkerSurveyor.vue?vue&type=script&lang=js&"
export * from "./BunkerSurveyor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports